import React from "react";

const Footer = () => {
  return (
    <div className="bg-[linear-gradient(0deg,_#060103_0%,_#870022_100%)] xl:px-[10%] lg:px-[8%] xs:px-[5%] md:px-[6%] sm:px-[5%]    py-4">
      <div className="py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Support Contact */}
          <p className="mb-0 text-white text-lg xs:text-[14px] font-medium text-center md:text-left">
            For any support, contact at{" "}
            <a
              className="text-white xs:text-[14px] underline hover:no-underline"
              href="mailto:chris@drunkmates.com"
            >
              chris@drunkmates.com
            </a>
          </p>
          {/* Footer Links */}
          <ul className="flex items-center gap-5 mt-3 md:mt-0">
            <li className="xs:text-[14px]">
              <a
                className="text-white xs:text-[14px] text-lg font-medium hover:underline"
                href="/privacy-policy"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                className="text-white xs:text-[14px] text-lg font-medium hover:underline"
                href="/terms&conditions"
              >Terms & Condition
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
